
      var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMobileGrayEmptyCouponLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 127,
  height: 168,
  textRendering: "geometricPrecision",
  viewBox: "0 0 127 168"
}, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH8AAACoCAMAAAD+WMG2AAAAGFBMVEVMaXGfn6Ogn6KgoKOgn6Kfn6Kfn6Ogn6JfdCpzAAAAB3RSTlMAGufBkmZAGMC4JgAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAgpJREFUeNrtnFuSxSAIROUh7n/HMzF6J3Pz77EK3UAnKDSNSGnYsnKtqhS+lns59QFx4wtlARPYABr9Cyp3Bg/+7zJs//3CFwxeUPdrtTsfHP/o+K8wfgmF+Sdg/sH8Xwf/YPFP64n/JP8PfGX331H+Ec76wcb/PfgnHOYf7PxN/sESoKANgPOPH/4h9ceNL1wEqqj+6OffNDf/GK0/uPIPrD9m+MW2oBY2/uP8MyqAR3+g+NzvW5D57x2AGrz5NP/k1R8G648P/1AGcJp/4vBPav3R8YOjv0v+gsb33PxjW9Tf3Gj9g1Hw5B+KAr38fYCRAgwLwkpvgRT2Ax74SBr0xF9vAH/CrzeAl/9LQOMDPmjf8IsTwTe+wPiLKxGv/V98APyF76wDLo8AKix+S47/bX/j8p8t/A+OP5Gcfwy5/98m/4DzLzr/hPNvpAy1j/5i9SesvwOtP4SRl49w/am1rPU/uv/v7j8xegMErL8H2n++yf1L4v479v5t3j863P9DOeAW9+90/0F2/qH7b+j+I5QA9+g/S8s/cP/7VF9w/6mw7z+C1T+WXP8YzD9g+B3zBzj9Md5/Hv2Rm3/g92eYA9Yd3h9Wa6f+lrL/vAU9fkZY/T/55+iPrPzD5h8qO8wfgeevaPL+a6Pnr4nR89da0vrDmT+QfP5Onz/A6Y9x/ln/5/THFvNvfgBGeidbFCAX8QAAAABJRU5ErkJggg==",
  width: 127,
  height: 168,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH8AAACoCAMAAAD+WMG2AAAAGFBMVEVMaXGfn6Ogn6KgoKOgn6Kfn6Kfn6Ogn6JfdCpzAAAAB3RSTlMAGufBkmZAGMC4JgAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAgpJREFUeNrtnFuSxSAIROUh7n/HMzF6J3Pz77EK3UAnKDSNSGnYsnKtqhS+lns59QFx4wtlARPYABr9Cyp3Bg/+7zJs//3CFwxeUPdrtTsfHP/o+K8wfgmF+Sdg/sH8Xwf/YPFP64n/JP8PfGX331H+Ec76wcb/PfgnHOYf7PxN/sESoKANgPOPH/4h9ceNL1wEqqj+6OffNDf/GK0/uPIPrD9m+MW2oBY2/uP8MyqAR3+g+NzvW5D57x2AGrz5NP/k1R8G648P/1AGcJp/4vBPav3R8YOjv0v+gsb33PxjW9Tf3Gj9g1Hw5B+KAr38fYCRAgwLwkpvgRT2Ax74SBr0xF9vAH/CrzeAl/9LQOMDPmjf8IsTwTe+wPiLKxGv/V98APyF76wDLo8AKix+S47/bX/j8p8t/A+OP5Gcfwy5/98m/4DzLzr/hPNvpAy1j/5i9SesvwOtP4SRl49w/am1rPU/uv/v7j8xegMErL8H2n++yf1L4v479v5t3j863P9DOeAW9+90/0F2/qH7b+j+I5QA9+g/S8s/cP/7VF9w/6mw7z+C1T+WXP8YzD9g+B3zBzj9Md5/Hv2Rm3/g92eYA9Yd3h9Wa6f+lrL/vAU9fkZY/T/55+iPrPzD5h8qO8wfgeevaPL+a6Pnr4nR89da0vrDmT+QfP5Onz/A6Y9x/ln/5/THFvNvfgBGeidbFCAX8QAAAABJRU5ErkJggg==",
  preserveAspectRatio: "none"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"127\" height=\"168\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 127 168\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH8AAACoCAMAAAD+WMG2AAAAGFBMVEVMaXGfn6Ogn6KgoKOgn6Kfn6Kfn6Ogn6JfdCpzAAAAB3RSTlMAGufBkmZAGMC4JgAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAgpJREFUeNrtnFuSxSAIROUh7n/HMzF6J3Pz77EK3UAnKDSNSGnYsnKtqhS+lns59QFx4wtlARPYABr9Cyp3Bg/+7zJs//3CFwxeUPdrtTsfHP/o+K8wfgmF+Sdg/sH8Xwf/YPFP64n/JP8PfGX331H+Ec76wcb/PfgnHOYf7PxN/sESoKANgPOPH/4h9ceNL1wEqqj+6OffNDf/GK0/uPIPrD9m+MW2oBY2/uP8MyqAR3+g+NzvW5D57x2AGrz5NP/k1R8G648P/1AGcJp/4vBPav3R8YOjv0v+gsb33PxjW9Tf3Gj9g1Hw5B+KAr38fYCRAgwLwkpvgRT2Ax74SBr0xF9vAH/CrzeAl/9LQOMDPmjf8IsTwTe+wPiLKxGv/V98APyF76wDLo8AKix+S47/bX/j8p8t/A+OP5Gcfwy5/98m/4DzLzr/hPNvpAy1j/5i9SesvwOtP4SRl49w/am1rPU/uv/v7j8xegMErL8H2n++yf1L4v479v5t3j863P9DOeAW9+90/0F2/qH7b+j+I5QA9+g/S8s/cP/7VF9w/6mw7z+C1T+WXP8YzD9g+B3zBzj9Md5/Hv2Rm3/g92eYA9Yd3h9Wa6f+lrL/vAU9fkZY/T/55+iPrPzD5h8qO8wfgeevaPL+a6Pnr4nR89da0vrDmT+QfP5Onz/A6Y9x/ln/5/THFvNvfgBGeidbFCAX8QAAAABJRU5ErkJggg==\" width=\"127\" height=\"168\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH8AAACoCAMAAAD+WMG2AAAAGFBMVEVMaXGfn6Ogn6KgoKOgn6Kfn6Kfn6Ogn6JfdCpzAAAAB3RSTlMAGufBkmZAGMC4JgAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAgpJREFUeNrtnFuSxSAIROUh7n/HMzF6J3Pz77EK3UAnKDSNSGnYsnKtqhS+lns59QFx4wtlARPYABr9Cyp3Bg/+7zJs//3CFwxeUPdrtTsfHP/o+K8wfgmF+Sdg/sH8Xwf/YPFP64n/JP8PfGX331H+Ec76wcb/PfgnHOYf7PxN/sESoKANgPOPH/4h9ceNL1wEqqj+6OffNDf/GK0/uPIPrD9m+MW2oBY2/uP8MyqAR3+g+NzvW5D57x2AGrz5NP/k1R8G648P/1AGcJp/4vBPav3R8YOjv0v+gsb33PxjW9Tf3Gj9g1Hw5B+KAr38fYCRAgwLwkpvgRT2Ax74SBr0xF9vAH/CrzeAl/9LQOMDPmjf8IsTwTe+wPiLKxGv/V98APyF76wDLo8AKix+S47/bX/j8p8t/A+OP5Gcfwy5/98m/4DzLzr/hPNvpAy1j/5i9SesvwOtP4SRl49w/am1rPU/uv/v7j8xegMErL8H2n++yf1L4v479v5t3j863P9DOeAW9+90/0F2/qH7b+j+I5QA9+g/S8s/cP/7VF9w/6mw7z+C1T+WXP8YzD9g+B3zBzj9Md5/Hv2Rm3/g92eYA9Yd3h9Wa6f+lrL/vAU9fkZY/T/55+iPrPzD5h8qO8wfgeevaPL+a6Pnr4nR89da0vrDmT+QfP5Onz/A6Y9x/ln/5/THFvNvfgBGeidbFCAX8QAAAABJRU5ErkJggg==\" preserveAspectRatio=\"none\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/mobileGrayEmptyCouponLeft.78992186cfbc4feffd90ca3154ae50a0.svg"),
        {
          React: SvgMobileGrayEmptyCouponLeft,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      